import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IAccommodationType {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  detached?: number | null;
  semiDetached?: number | null;
  terraced?: number | null;
  purposeBuiltBlockFlats?: number | null;
  convertedSharedHouse?: number | null;
  convertedBuilding?: number | null;
  commercialBuilding?: number | null;
  caravanMobile?: number | null;
}

export const defaultValue: Readonly<IAccommodationType> = {};
